export default __webpack_public_path__ + "static/media/payment-system.8012bcc1.png";